import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import CourseCard from '../../components/Cours/CourseCard';
import { useNavigate } from 'react-router-dom';

const courses = [
   {
      id: 1,
      image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      title: "Learn Figma - UI/UX Design Essential Training",
      rating: 4.5,
      total_reviews: 1991,
      total_lessons: 6,
      estimated_duration_hours: 3,
      estimated_duration_minutes: 56,
      difficulty_level: "Beginner",
      instructor_name: "Ali Tufan",
      instructor_avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      price: 179,
      discounted_price: 79
   },
   {
      id: 2,
      image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      title: "Complete Python Bootcamp From Zero to Hero in Python",
      rating: 4.7,
      total_reviews: 2450,
      total_lessons: 8,
      estimated_duration_hours: 5,
      estimated_duration_minutes: 30,
      difficulty_level: "Intermediate",
      instructor_name: "Sarah Johnson",
      instructor_avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      price: 199,
      discounted_price: 89,
      tags: ["POPULAR", "BEST SELLER"]
   },
   {
      id: 3,
      image: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      title: "Angular - The Complete Guide (2023 Edition)",
      rating: 4.6,
      total_reviews: 1876,
      total_lessons: 10,
      estimated_duration_hours: 7,
      estimated_duration_minutes: 15,
      difficulty_level: "Advanced",
      instructor_name: "Michael Chen",
      instructor_avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      price: 219,
      discounted_price: 99
   },
   {
      id: 4,
      image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      title: "The Ultimate Drawing Course Beginner to Advanced",
      rating: 4.8,
      total_reviews: 3210,
      total_lessons: 12,
      estimated_duration_hours: 9,
      estimated_duration_minutes: 45,
      difficulty_level: "All Levels",
      instructor_name: "Emma Wilson",
      instructor_avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      price: 189,
      discounted_price: 79
   },
   {
      id: 5,
      image: "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      title: "Photography Masterclass: A Complete Guide to Photography",
      rating: 4.9,
      total_reviews: 4125,
      total_lessons: 14,
      estimated_duration_hours: 11,
      estimated_duration_minutes: 20,
      difficulty_level: "Beginner",
      instructor_name: "David Miller",
      instructor_avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      price: 249,
      discounted_price: 119
   },
   {
      id: 6,
      image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      title: "Instagram Marketing 2023: Complete Guide To Instagram",
      rating: 4.4,
      total_reviews: 1567,
      total_lessons: 7,
      estimated_duration_hours: 4,
      estimated_duration_minutes: 10,
      difficulty_level: "Intermediate",
      instructor_name: "Sophia Garcia",
      instructor_avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      price: 169,
      discounted_price: 69
   },
   {
      id: 7,
      image: "https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      title: "Complete Blender Creator: Learn 3D Modelling for Beginners",
      rating: 4.7,
      total_reviews: 2789,
      total_lessons: 9,
      estimated_duration_hours: 6,
      estimated_duration_minutes: 45,
      difficulty_level: "Beginner",
      instructor_name: "Robert Kim",
      instructor_avatar: "https://images.unsplash.com/photo-1508341591423-4347099e1f19?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      price: 199,
      discounted_price: 89
   },
   {
      id: 8,
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      title: "The Complete Financial Analyst Training & Investing Course",
      rating: 4.6,
      total_reviews: 1923,
      total_lessons: 11,
      estimated_duration_hours: 8,
      estimated_duration_minutes: 30,
      difficulty_level: "Advanced",
      instructor_name: "Jennifer Lee",
      instructor_avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      price: 229,
      discounted_price: 109
   }
];

const FeaturedCourses = () => {
   const [activeTab, setActiveTab] = useState('all');
   const carouselRef = useRef(null);
   const [currentIndex, setCurrentIndex] = useState(0);
   const [visibleCards, setVisibleCards] = useState(4);
   const navigate = useNavigate();

   const handleCourseClick = (courseId) => {
      navigate(`/courses-single/${courseId}`);
   };

   // Filtrage des cours en fonction de l'onglet actif
   const filteredCourses = (activeTab === 'all' || activeTab === 'trending' || activeTab === 'popular' || activeTab === 'featured')
      ? courses
      : courses.filter(course => course.tags.includes(activeTab));

   // Déterminer le nombre de cartes visibles en fonction de la largeur de l'écran
   useEffect(() => {
      const handleResize = () => {
         if (typeof window !== 'undefined') {
            if (window.innerWidth >= 1280) {
               setVisibleCards(4); // xl
            } else if (window.innerWidth >= 1024) {
               setVisibleCards(3); // lg
            } else if (window.innerWidth >= 768) {
               setVisibleCards(2); // md
            } else {
               setVisibleCards(1);  // sm
            }
         }
      };

      // Initial call
      handleResize();

      // Add event listener
      window.addEventListener('resize', handleResize);

      // Clean up
      return () => window.removeEventListener('resize', handleResize);
   }, []);

   const scrollToIndex = (index) => {
      if (!carouselRef.current) return;

      const card = carouselRef.current.children[0];
      if (!card) return;

      const cardWidth = card.offsetWidth;
      const gap = 24;
      const scrollPosition = index * (cardWidth + gap);

      carouselRef.current.scrollTo({
         left: scrollPosition,
         behavior: 'smooth'
      });

      setCurrentIndex(index);
   };

   const scrollPrev = () => {
      const newIndex = Math.max(0, currentIndex - 1);
      scrollToIndex(newIndex);
   };

   const scrollNext = () => {
      const maxIndex = Math.max(0, filteredCourses.length - visibleCards);
      const newIndex = Math.min(maxIndex, currentIndex + 1);
      scrollToIndex(newIndex);
   };

   return (
      <section className="py-12 md:py-16 lg:py-24 dark:bg-dark-2 rounded-xl">
         <div className="container mx-auto px-4 md:px-6 lg:px-8">
            <div className="mb-8 md:mb-12">
               <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 md:gap-6 mb-6 md:mb-8">
                  <div className="text-center md:text-left">
                     <h2 className="text-2xl md:text-3xl font-bold text-dark-1 dark:text-white mb-2">Les Modules</h2>
                  </div>

                  <div className="flex flex-wrap gap-2 justify-center md:justify-start w-full md:w-auto">
                     {['all', 'trending', 'popular', 'featured'].map((tab) => (
                        <button
                           key={tab}
                           onClick={() => {
                              setActiveTab(tab);
                              setCurrentIndex(0);
                           }}
                           className={`px-3 sm:px-4 md:px-5 py-1.5 md:py-2 text-xs sm:text-sm md:text-base rounded-full capitalize ${activeTab === tab
                              ? 'bg-gray-100 dark:bg-dark-5 text-purple-1 dark:text-purple-300'
                              : 'text-dark-1 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-5'
                              }`}
                        >
                           {tab}
                        </button>
                     ))}
                  </div>
               </div>

               <div className="relative">
                  <div
                     ref={carouselRef}
                     className="flex overflow-x-auto gap-6 scroll-smooth py-2 snap-x snap-mandatory hide-scrollbar"
                     style={{
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none'
                     }}
                  >
                     {filteredCourses.map((course, index) => (
                        <div
                           key={course.id}
                           className="flex-none snap-start"
                           style={{
                              width: `calc((100% - ${(visibleCards - 1) * 24}px) / ${visibleCards})`,
                              minWidth: "280px"
                           }}
                        >
                           <CourseCard course={course} animationDelay={index + 1} onClick={() => handleCourseClick(course.id)} />
                        </div>
                     ))}
                  </div>

                  {/* Boutons de navigation */}
                  {filteredCourses.length > visibleCards && (
                     <>
                        <button
                           onClick={scrollPrev}
                           className={`absolute -left-3 md:-left-4 top-1/2 transform -translate-y-1/2 bg-white dark:bg-dark-5 text-dark-1 dark:text-white 
                           w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 rounded-full shadow-lg flex items-center justify-center hover:bg-purple-1 dark:hover:bg-purple-300
                           hover:text-white transition-colors z-10 ${currentIndex === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                           disabled={currentIndex === 0}
                        >
                           <FontAwesomeIcon icon={faArrowLeft} className="text-xs md:text-sm" />
                        </button>

                        <button
                           onClick={scrollNext}
                           className={`absolute -right-3 md:-right-4 top-1/2 transform -translate-y-1/2 bg-white dark:bg-dark-5 text-dark-1 dark:text-white
                           w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 rounded-full shadow-lg flex items-center justify-center hover:bg-purple-1 dark:hover:bg-purple-300
                           hover:text-white transition-colors z-10 ${currentIndex >= filteredCourses.length - visibleCards ? 'opacity-50 cursor-not-allowed' : ''}`}
                           disabled={currentIndex >= filteredCourses.length - visibleCards}
                        >
                           <FontAwesomeIcon icon={faArrowRight} className="text-xs md:text-sm" />
                        </button>
                     </>
                  )}
               </div>
            </div>
         </div>

         <style jsx>{`
            .hide-scrollbar::-webkit-scrollbar {
               display: none;
            }
         `}</style>
      </section>
   );
};

export default FeaturedCourses;